import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import buttonShapes from "@insite/mobius/Button/buttonShapes";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css, ThemeProps, withTheme } from "styled-components";

export interface HomeStyles {
    mainContainer?: InjectableCss;
}
const styles: HomeStyles = {
    mainContainer: {
        css: css`
            > div > div[class^="GridWrapper"] {
                margin: 0 auto;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                .categoriesSubWrapper {
                                    div[class^="GridOffset"] {
                                        width: 100%;
                                    }
                                }
                                .categoriesSubBannerWrapper {
                                    div[class^="GridOffset"] {
                                        width: 100%;
                                    }
                                }
                            `,
                            css`
                                .categoriesSubWrapper {
                                    div[class^="GridOffset"] {
                                        width: 100%;
                                    }
                                }
                                .categoriesSubBannerWrapper {
                                    div[class^="GridOffset"] {
                                        width: 100%;
                                    }
                                }
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
            }
            .homepageBanner-Wrapper {
                position: relative;
                .homepageBanner-topImg {
                    img {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        height: 200px;
                                    `,
                                    css`
                                        height: 200px;
                                    `,
                                    null,
                                    null,
                                ],
                                "minMax",
                            );
                        }}
                    }
                }
                .homepageBanner-text {
                    position: absolute;
                    left: 12%;
                    top: 50%;
                    transform: translateY(-50%);
                    > h1 {
                        font-style: normal;
                        line-height: 1;
                        color: #ffffff;
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        font-size: 19px;
                                    `,
                                    css`
                                        font-size: 19px;
                                    `,
                                    css`
                                        font-size: 40px;
                                    `,
                                    css`
                                        font-size: 65px;
                                    `,
                                ],
                                "minMax",
                            );
                        }}
                    }
                    .industrial-supply {
                        font-weight: 600;
                    }
                }
                .learnMore-button {
                    height: 55px;
                    padding: 0 50px;
                    background: #ffffff;
                    border-radius: 5px;
                    > span {
                        color: #000;
                    }
                }
                .homepageCategoryBanner-text {
                    position: absolute;
                    inset: 1em;
                    padding: 60px 20px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 30px 20px;
                                `,
                                css`
                                    padding: 30px 20px;
                                `,
                                css`
                                    padding: 10px;
                                `,
                                css`
                                    padding: 30px 20px;
                                `,
                            ],
                            "minMax",
                        );
                    }}
                    > h3[class^="TypographyStyle"] {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        text-align: center;
                                        font-size: 25px;
                                    `,
                                    css`
                                        text-align: center;
                                        font-size: 25px;
                                    `,
                                    css`
                                        font-size: 23px;
                                    `,
                                    css`
                                        font-size: 25px;
                                    `,
                                ],
                                "minMax",
                            );
                        }}
                    }
                }
                .homepageCategoryBanner2-text {
                    position: absolute;
                    inset: 1em;
                    padding: 30px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding: 10px;
                                `,
                                css`
                                    padding: 25px;
                                `,
                            ],
                            "minMax",
                        );
                    }}
                    > h3[class^="TypographyStyle"] {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        font-size: 25px;
                                    `,
                                    css`
                                        font-size: 25px;
                                    `,
                                    css`
                                        font-size: 23px;
                                    `,
                                    css`
                                        font-size: 25px;
                                    `,
                                ],
                                "minMax",
                            );
                        }}
                    }
                }
                .homepageBanner-bottomImg {
                    img {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        height: 200px;
                                    `,
                                    css`
                                        height: 200px;
                                    `,
                                    css`
                                        height: 400px;
                                    `,
                                    css`
                                        height: 400px;
                                    `,
                                ],
                                "minMax",
                            );
                        }}
                    }
                }
                .homepageBottomBanner-text {
                    position: absolute;
                    left: 12%;
                    top: 50%;
                    transform: translateY(-50%);
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    top: 20%;
                                `,
                                css`
                                    top: 20%;
                                `,
                                null,
                                null,
                            ],
                            "minMax",
                        );
                    }}
                    > h2 {
                        line-height: 0.8;
                        font-size: 50px;
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        font-size: 19px;
                                    `,
                                    css`
                                        font-size: 19px;
                                    `,
                                    css`
                                        font-size: 32px;
                                    `,
                                    css`
                                        font-size: 40px;
                                    `,
                                ],
                                "minMax",
                            );
                        }}
                    }
                    .inventoryText {
                        margin-bottom: 1.1em;
                    }
                }
                .homepageBottomBanner2-text {
                    align-items: end;
                    position: absolute;
                    top: 8em;
                    left: 56em;
                    display: flex;
                    right: 0;
                    background: #333332;
                    opacity: 0.9;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    position: unset;
                                    top: 0;
                                    left: 0;
                                    margin: 20px 0;
                                `,
                                css`
                                    position: unset;
                                    top: 0;
                                    left: 0;
                                    margin: 20px 0;
                                `,
                                css`
                                    left: 34em;
                                    top: 50%;
                                    transform: translateY(-50%);
                                `,
                                css`
                                    left: 42em;
                                    top: 50%;
                                    transform: translateY(-50%);
                                `,
                                css`
                                    top: 50%;
                                    transform: translateY(-50%);
                                `,
                            ],
                            "minMax",
                        );
                    }}
                    > p {
                        padding: 30px 150px 20px 10px;
                        color: #ffffff;
                        line-height: 1.2;
                        letter-spacing: 2px;
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        padding: 30px;
                                    `,
                                    css`
                                        padding: 30px;
                                    `,
                                    css`
                                        padding: 5px 10px;
                                    `,
                                    css`
                                        padding: 30px 100px 20px 10px;
                                    `,
                                ],
                                "minMax",
                            );
                        }}
                    }
                }
            }

            .hrLineWrapper {
                > div[class^="GridOffset"] {
                    margin: 0 auto;
                    width: 100%;
                }
            }
            .homepage-text {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 0 30px;
                            `,
                            css`
                                padding: 0 30px;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
                > p {
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    display: contents;
                                `,
                                css`
                                    display: contents;
                                `,
                                null,
                                null,
                            ],
                            "minMax",
                        );
                    }}
                }
            }
            .categoriesWrapper {
                padding: 40px 170px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 40px 30px;
                            `,
                            css`
                                padding: 40px 30px;
                            `,
                            css`
                                padding: 40px 30px;
                            `,
                            css`
                                padding: 40px 100px;
                            `,
                        ],
                        "minMax",
                    );
                }}
                > div[class^="GridOffset"] {
                    margin: 0 auto;
                    width: 100%;
                }
            }
            .homepageBottom-text {
                padding: 80px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 30px 10px 50px 10px;
                            `,
                            css`
                                padding: 30px 10px 50px 10px;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
                > div[class^="GridOffset"] {
                    > div[class^="GridItemStyle"] {
                        > div[class^="Wrapper"] {
                            > div[class^="ContentWrapper"]:first-child {
                                > p {
                                    ${({ theme }) => {
                                        return breakpointMediaQueries(
                                            theme,
                                            [
                                                css`
                                                    display: contents;
                                                `,
                                                css`
                                                    display: contents;
                                                `,
                                                null,
                                                null,
                                            ],
                                            "minMax",
                                        );
                                    }}
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
};

const HomePage = ({ id }: PageProps) => (
    <Page
        data-test-selector="homePage"
        css={css`
            padding: 0;
        `}
        fullWidth={[true, true, true, true, true]}
        {...styles.mainContainer}
    >
        <Zone contentId={id} zoneName="Content" />
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...StructuredPageData,
                tooltip:
                    "Code entered in this field will be added to the head of the home page. This field only supports JSON-LD data.",
            },
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

export const HomePageContext = "HomePage";
